import Vue from 'vue'
import 'es6-promise/auto'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import axios from 'axios'

// eslint-disable-next-line consistent-return
async function getUnseenFiles() {
	try {
		// eslint-disable-next-line no-undef
		const countRes = await axios.get(`${config.baseAPIurl}/index/unseen-files`)
		return countRes.data.unseenFileCount
	} catch (error) {
		console.log('error in unseen file count getter')
	}
}

Vue.use(Vuex, {
	computed: {
		count() {
			// eslint-disable-next-line no-undef
			return state.count
		},
	},
	methods: {
		increment() {
			// eslint-disable-next-line no-undef
			state.commit('increment')
		},
		decrement() {
			// eslint-disable-next-line no-undef
			state.commit('decrement')
		},
		reset() {
			// eslint-disable-next-line no-undef
			state.commit('reset')
		},
		unseenFiles() {
			// eslint-disable-next-line no-undef
			state.commit('unseenFiles')
		},
	},
})

export default new Vuex.Store({
	state: {
		count: 0,
		unseenFileCount: 0,
		unseenFileShow: false,
	},
	plugins: [createPersistedState()],
	mutations: {
		// eslint-disable-next-line no-return-assign
		increment: (state) => state.count += 1,
		// eslint-disable-next-line no-return-assign
		decrement: (state) => state.count -= 1,
		// eslint-disable-next-line no-return-assign
		reset: (state) => state.count = 0,
		unseenFiles: async (state) => {
			state.unseenFileShow = false
			const unseenFileCount = await getUnseenFiles()
			state.unseenFileCount = unseenFileCount
			if (state.unseenFileCount > 0) {
				state.unseenFileShow = true
			}
		},
	},
	setters: {
		/* empty atm */
	},
	getters: {
		/* empty atm */
	},
})
